import { Dispatch, SetStateAction, createContext } from "react"

export interface MarketPlaceAuthGuardGateI  {
  isGateLocked: boolean
}

const MarketPlaceAuthGuardGateContext = createContext({} as MarketPlaceAuthGuardGateI)

export default MarketPlaceAuthGuardGateContext
